// extracted by mini-css-extract-plugin
export default {"backToTop":"backtottop_backToTop__wcGMF","icon":"backtottop_icon__ElUX8"};